(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('[data-trial-tasting]:not([data-tasting-ready])').forEach(tasting => {
      const choices = [...tasting.querySelectorAll('[data-tasting-choice]')];
      const panels = [...tasting.querySelectorAll('[data-tasting-panel]')];
      if (choices.length !== 3 || panels.length !== 3) return;
      const select = index => {
        choices.forEach((choice, i) => choice.setAttribute('aria-pressed', String(i === index)));
        panels.forEach((panel, i) => { panel.hidden = i !== index; });
      };
      choices.forEach((choice, index) => choice.addEventListener('click', () => select(index)));
      select(0); tasting.querySelector('.j-tasting__choices').hidden = false;
      tasting.dataset.tastingReady = 'true';
    });
  }
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();
